import { Content } from 'pages/Content';

export const CycleHighlights = () => {
  return (
    <Content
      showHeaderCarrossel
      document='destaques_do_ciclo'
      title='Destaques do ciclo'
      description='Todas as atualizações, lançamentos e promoções do ciclo atual.'
    />
  );
};
